<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

/**
 * Starter page component
 */
export default {
    page() {
        return {
            title: this.title,
            meta: [{ name: "description" }],
        };
    },
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Starter page",
            items: [
                {
                    text: "Utility",
                    href: "/",
                },
                {
                    text: "Starter page",
                    active: true,
                },
            ],
            loading: false,
            userinfo: [],
            createForm: {
                identity_type: "company",
                company_name: "",
                company_number: "",
                phone: "",
                personal_wechat: "",
            },
            securityDialogVisible: false,
            securityCountdown: 5,
            pendingCreatePayload: null,
            securityCountdownTimer: null,
            authQrcodeDialogVisible: false,
            authQrcodeUrl: "",
        };
    },
    computed: {
        securityConfirmLabel() {
            return this.securityCountdown > 0
                ? `确认（${this.securityCountdown}s）`
                : "确认";
        },
        /** 新版本仅支持 18 位统一社会信用代码（见微信第三方服务商 API 调整公告） */
        enterpriseCodePlaceholder() {
            return "18 位统一社会信用代码";
        },
    },
    mounted() {
        this.userinfo = JSON.parse(localStorage.getItem("user"));
        this.title = "创建小程序";
        this.items = [
            {
                text: this.$t("menuitems.micoapp.text"),
                href: "/",
            },
            {
                text: this.$t("menuitems.icp.micoapp.list"),
                href: "/micoapp",
            },
            {
                text: "创建小程序",
                active: true,
            },
        ];
    },
    beforeDestroy() {
        this.clearSecurityCountdown();
    },
    methods: {
        buildHeaders() {
            return this.userinfo && this.userinfo.openid ? { Openid: this.userinfo.openid } : {};
        },
        isUnifiedSocialCreditCode(value) {
            const t = String(value || "").trim().toUpperCase();
            if (t.length !== 18) return false;
            return /^[0-9A-Z]{18}$/.test(t);
        },
        ensureRequired() {
            const fields = this.createForm.identity_type === "personal"
                ? [
                    { key: "personal_wechat", label: "微信号" },
                    { key: "phone", label: "联系电话" },
                ]
                : [
                    { key: "company_name", label: "企业名称" },
                    { key: "company_number", label: "统一社会信用代码" },
                    { key: "phone", label: "联系电话" },
                ];
            for (const field of fields) {
                if (!String(this.createForm[field.key] || "").trim()) {
                    this.$message.error(`请填写${field.label}`);
                    return false;
                }
            }
            if (this.createForm.identity_type === "company") {
                if (!this.isUnifiedSocialCreditCode(this.createForm.company_number)) {
                    this.$message.error("企业代码须为 18 位统一社会信用代码");
                    return false;
                }
            }
            return true;
        },
        buildCreatePayload() {
            if (this.createForm.identity_type === "personal") {
                return {
                    action: "create",
                    register_type: "personal",
                    wechat: this.createForm.personal_wechat.trim(),
                    phone: this.createForm.phone.trim(),
                };
            }
            return {
                action: "create",
                register_type: "company",
                company_name: this.createForm.company_name.trim(),
                company_number: this.createForm.company_number.trim().toUpperCase(),
                phone: this.createForm.phone.trim(),
            };
        },
        clearSecurityCountdown() {
            if (this.securityCountdownTimer != null) {
                clearInterval(this.securityCountdownTimer);
                this.securityCountdownTimer = null;
            }
        },
        startSecurityCountdown() {
            this.clearSecurityCountdown();
            this.securityCountdown = 5;
            this.securityCountdownTimer = setInterval(() => {
                if (this.securityCountdown <= 1) {
                    this.securityCountdown = 0;
                    this.clearSecurityCountdown();
                } else {
                    this.securityCountdown -= 1;
                }
            }, 1000);
        },
        createMicoapp() {
            if (!this.ensureRequired()) return;
            this.pendingCreatePayload = this.buildCreatePayload();
            this.securityDialogVisible = true;
            this.startSecurityCountdown();
        },
        closeSecurityDialog() {
            this.clearSecurityCountdown();
            this.securityDialogVisible = false;
            this.pendingCreatePayload = null;
        },
        confirmSecurityAndSubmit() {
            if (this.securityCountdown > 0 || !this.pendingCreatePayload) return;
            const payload = this.pendingCreatePayload;
            this.closeSecurityDialog();
            this.doCreateRequest(payload);
        },
        resetCreateForm() {
            Object.assign(this.createForm, {
                identity_type: "company",
                company_name: "",
                company_number: "",
                phone: "",
                personal_wechat: "",
            });
            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.clearValidate();
                }
            });
        },
        /** 从创建接口响应中解析授权验证链接 */
        extractAuthUrl(data) {
            if (!data || typeof data !== "object") return "";
            const candidates = [
                data.authorize_url,
                data.authorizeUrl,
                data.auth_url,
                data.authUrl,
                data.verify_url,
                data.verifyUrl,
                data.url,
                data.data && data.data.authorize_url,
                data.data && data.data.authorizeUrl,
                data.data && data.data.auth_url,
                data.data && data.data.authUrl,
                data.data && data.data.verify_url,
                data.data && data.data.verifyUrl,
                data.data && data.data.url,
                data.data && data.data.result && data.data.result.authorize_url,
                data.data && data.data.result && data.data.result.auth_url,
                data.result && data.result.authorize_url,
                data.result && data.result.auth_url,
            ];
            for (const item of candidates) {
                const url = String(item || "").trim();
                if (url && /^https?:\/\//i.test(url)) return url;
            }
            return "";
        },
        authQrImgUrl(url) {
            if (!url) return "";
            return "https://payapi.aic.pet/qr.png?data=" + encodeURIComponent(url);
        },
        showAuthQrcodeDialog(authUrl) {
            this.authQrcodeUrl = authUrl;
            this.authQrcodeDialogVisible = true;
        },
        closeAuthQrcodeDialog() {
            this.authQrcodeDialogVisible = false;
            this.authQrcodeUrl = "";
        },
        copyAuthUrl() {
            const url = this.authQrcodeUrl;
            if (!url) return;
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(url).then(
                    () => this.$message.success("链接已复制"),
                    () => this.fallbackCopyAuthUrl(url)
                );
            } else {
                this.fallbackCopyAuthUrl(url);
            }
        },
        fallbackCopyAuthUrl(url) {
            const input = document.createElement("textarea");
            input.value = url;
            input.setAttribute("readonly", "readonly");
            input.style.position = "fixed";
            input.style.left = "-9999px";
            document.body.appendChild(input);
            input.select();
            try {
                document.execCommand("copy");
                this.$message.success("链接已复制");
            } catch (e) {
                this.$message.error("复制失败，请手动选择链接复制");
            }
            document.body.removeChild(input);
        },
        openAuthUrl() {
            if (this.authQrcodeUrl) {
                window.open(this.authQrcodeUrl, "_blank", "noopener,noreferrer");
            }
        },
        doCreateRequest(payload) {
            const that = this;
            that.loading = true;
            that.$axios
                .post(that.apiuri, payload, { headers: that.buildHeaders() })
                .then(function (response) {
                    that.loading = false;
                    const data = response.data;
                    const ok =
                        data &&
                        (Number(data.errcode) === 0 ||
                            Number(data.status) === 200 ||
                            Number(data.code) === 0);
                    if (ok) {
                        that.resetCreateForm();
                        const authUrl = that.extractAuthUrl(data);
                        if (authUrl) {
                            that.showAuthQrcodeDialog(authUrl);
                        } else {
                            that.$alert(
                                "创建请求已提交，但接口未返回授权验证链接。请稍后在管理端查看，或联系服务商获取链接；用户须在 24 小时内完成验证。",
                                "提示",
                                {
                                    confirmButtonText: "确定",
                                    type: "warning",
                                }
                            );
                        }
                    } else {
                        const msg =
                            data && data.errmsg ? data.errmsg : "创建失败";
                        that.$alert(msg, "提示", {
                            confirmButtonText: "确定",
                            type: "error",
                        });
                    }
                })
                .catch(function (error) {
                    that.loading = false;
                    const msg =
                        (error &&
                            error.response &&
                            error.response.data &&
                            error.response.data.errmsg) ||
                        error.message ||
                        "请求失败";
                    that.$alert(msg, "请求错误", {
                        confirmButtonText: "确定",
                        type: "error",
                    });
                });
        },
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="micoapp-page">
          <div class="row">
              <div class="col-12">
                  <div class="card">
                      <div class="card-body" v-loading="loading">
                          <div class="micoapp-toolbar">
                              <div class="micoapp-toolbar-title">
                                  <h5>创建小程序</h5>
                              </div>
                          </div>
                          <el-form ref="form" :model="createForm" label-width="140px" class="micoapp-form">
                              <el-form-item label="主体类型">
                                  <el-radio-group v-model="createForm.identity_type">
                                      <el-radio label="company">企业</el-radio>
                                      <el-radio label="personal">个人</el-radio>
                                  </el-radio-group>
                              </el-form-item>
                              <template v-if="createForm.identity_type === 'company'">
                              <el-form-item label="企业名称">
                                  <el-input v-model="createForm.company_name" placeholder="与工商部门登记信息一致"></el-input>
                              </el-form-item>
                              <el-form-item label="统一社会信用代码">
                                  <el-input v-model="createForm.company_number" maxlength="18" show-word-limit :placeholder="enterpriseCodePlaceholder"></el-input>
                              </el-form-item>
                              <el-form-item label="联系电话">
                                  <el-input v-model="createForm.phone" placeholder="必填"></el-input>
                              </el-form-item>
                              </template>
                              <template v-else>
                              <el-form-item label="微信号">
                                  <el-input v-model="createForm.personal_wechat" placeholder="请输入微信号"></el-input>
                              </el-form-item>
                              <el-form-item label="联系电话">
                                  <el-input v-model="createForm.phone" placeholder="必填"></el-input>
                              </el-form-item>
                              </template>
                              <el-form-item>
                                  <el-button type="primary" @click="createMicoapp">提交创建</el-button>
                              </el-form-item>
                          </el-form>
                      </div>
                  </div>
              </div>
          </div>
        </div>
        <el-dialog
            title="重要提示"
            :visible.sync="securityDialogVisible"
            width="480px"
            append-to-body
            :close-on-click-modal="false"
            @close="closeSecurityDialog"
        >
            <p style="margin: 0 0 12px; line-height: 1.6;">
                接口成功后，微信将向<strong>服务商</strong>下发<strong>授权验证链接</strong>，不再向用户发送模版消息验证。请由本系统或管理端将链接转为二维码或发送给用户，用户须在 <strong>24 小时内</strong>完成验证。
            </p>
            <p style="margin: 0; color: #909399; font-size: 13px;">
                请阅读上述说明，{{ securityCountdown > 0 ? `${securityCountdown} 秒后可确认提交` : "可点击确认提交" }}。
            </p>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeSecurityDialog">取消</el-button>
                <el-button
                    type="primary"
                    :disabled="securityCountdown > 0"
                    @click="confirmSecurityAndSubmit"
                >{{ securityConfirmLabel }}</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="授权验证"
            :visible.sync="authQrcodeDialogVisible"
            width="420px"
            append-to-body
            :close-on-click-modal="false"
            @close="closeAuthQrcodeDialog"
        >
            <div class="micoapp-create-auth-dialog text-center">
                <p class="micoapp-create-auth-tip">
                    创建成功。请用户使用微信扫描下方二维码，或打开链接完成授权验证（24 小时内有效）。
                </p>
                <img
                    v-if="authQrcodeUrl"
                    :src="authQrImgUrl(authQrcodeUrl)"
                    alt="授权验证二维码"
                    class="micoapp-create-auth-qr"
                />
                <el-input
                    v-if="authQrcodeUrl"
                    type="textarea"
                    :rows="3"
                    :value="authQrcodeUrl"
                    readonly
                    class="micoapp-create-auth-link mt-3"
                />
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="copyAuthUrl">复制链接</el-button>
                <el-button @click="openAuthUrl">打开链接</el-button>
                <el-button type="primary" @click="closeAuthQrcodeDialog">确定</el-button>
            </span>
        </el-dialog>
    </Layout>
</template>

<style scoped>
.micoapp-create-auth-tip {
    margin: 0 0 16px;
    line-height: 1.6;
    color: #606266;
    text-align: left;
}

.micoapp-create-auth-qr {
    width: 260px;
    max-width: 100%;
    height: auto;
}

.micoapp-create-auth-link {
    text-align: left;
}
</style>
